export const timestampToRelativeTimeText = (timestamp: number): string => {
  const now = Date.now();
  const diffSeconds = Math.round((now - timestamp) / 1000);
  const absSeconds = Math.abs(diffSeconds);

  if (absSeconds < 30) return 'just now';

  const rtf = new Intl.RelativeTimeFormat(undefined, { numeric: 'auto' });

  const divisions = [
    { amount: 60, unit: 'second' as const },
    { amount: 60, unit: 'minute' as const },
    { amount: 24, unit: 'hour' as const },
    { amount: 7, unit: 'day' as const },
    { amount: 4.34524, unit: 'week' as const },
    { amount: 12, unit: 'month' as const },
    { amount: Number.POSITIVE_INFINITY, unit: 'year' as const },
  ];

  let duration = diffSeconds;
  let unit: Intl.RelativeTimeFormatUnit = 'second';

  for (const division of divisions) {
    if (Math.abs(duration) < division.amount) {
      unit = division.unit;
      break;
    }
    duration /= division.amount;
  }

  duration = Math.trunc(duration);
  return rtf.format(-Math.abs(duration), unit);
};
